AutoCompleteSearch = function (
    endPoint,
    inputSelector,
    containerSelector,
    hitProcessors,
    hitTemplates

) {
    var that = this;
    that.endPoint = endPoint;
    that.containerSelector = containerSelector;
    that.inputSelector = inputSelector;
    $(inputSelector).on('input', that.inputHandler.bind(that));
    $('body').click(that.focusoutHandler.bind(that));
    $(inputSelector).focus(that.showResults.bind(that));
    that.hitProcessors = hitProcessors;
    that.hitTemplates = hitTemplates;
}

AutoCompleteSearch.prototype = {
    endPoint : null,
    inputSelector : null,
    containerSelector : null,
    hitProcessors: null,
    hitTemplates : null,
    params: null,
    requestParams: null,
    categories: null,
    defaultCategoryLength : 10,
    additionalClasses: null,
    searching: false,

    search: function(query) {
        if (this.searching) { return; }

        // handling searching
        var self = this; this.searching = true;
        setTimeout(function() { self.searching = false; }, 100);

        this.params = {q: query.trim()};

        if (this.additionalParams)
            this.params = $.extend(this.params, this.additionalParams);

        if (this.fixedParams)
            this.params = $.extend(this.params, this.fixedParams);

        this.requestParams = {
            'type': 'get',
            'data': this.params,
            'dataType': "json",
            'contentType': 'application/json',
        };
        $.ajax(this.endPoint, this.requestParams)
            .done(this.processResult.bind(this));
    },

    processResult: function(result) {
        if (
            !(Array.isArray(this.categories) && this.categories.length) &&
            !this.category
        ) {
            throw ('Required category settings missing.');
        }

        this.clearResults();

        var that = this;

        if (this.categories && this.categories.length) {

            var defaultLengthTotal = 0;
            var resultLengthTotal = 0;

            var resultCategories = {};

            // Opbouwen van output categorieën en
            // bijhouden van aantal resultaten
            $.each(this.categories, function (i,category) {

                var hits = category.name != 'publisher' ? result[category.name].hits.hits : result[category.name].aggregations.publishers.buckets;

                // Aantal resultaten binnen categorie
                defaultLengthTotal+= category.defaultLength ?
                    category.defaultLength : that.defaultCategoryLength;

                // Totaal aantal resultaten alle categorieën
                resultLengthTotal+= hits.length;

                // Output categorie
                resultCategories[category.name] = {
                    'name' : category.name,
                    'description' : category.description,
                    'hits' : hits,
                    'length' : hits.length,
                    'outputLength' : hits.length,
                };
            });

            // Verdelen van resultaten over categorieën indien
            // er meer resultaten zijn dan er ruimte is in de output.
            if (resultLengthTotal > defaultLengthTotal) {

                var numMissing = defaultLengthTotal;

                $.each(that.categories, function (i,category) {

                    var resultCategory = resultCategories[category.name];

                    // Standaaardlengte vanuit categorie configuratie,
                    // indien afwezig vanuit component configuratie
                    var categoryDefaultLength = category.defaultLength ?
                        category.defaultLength : that.defaultCategoryLength;

                    var outputLength = Math.min(categoryDefaultLength, resultCategory.length);

                    resultCategory['outputLength'] = outputLength;
                    numMissing-= outputLength;
                });

                $.each(that.categories, function (i,category) {

                    var resultCategory = resultCategories[category.name];

                    while (numMissing > 0 && resultCategory.length - resultCategory.outputLength > 0) {
                        resultCategory.outputLength++;
                        numMissing--;
                    }
                });

            }

            $.each(resultCategories, function(categoryName, resultCategory) {

                // Overslaan van categorie indien leeg
                if (!resultCategory.outputLength)
                    return;

                var container = $('<ul class="autocomplete-' + categoryName + '-container '+that.additionalClasses+'"><li class="autocomplete-result-title">' + resultCategory.description + '</li></ul>');

                for (var p=0; p<resultCategory.outputLength; p++) {
                    var hit = categoryName != 'publisher' ? resultCategory.hits[p] : resultCategory.hits[p].publisher_info.hits.hits[0];
                    that.processHit(hit, categoryName, container);
                }

                container.appendTo(that.containerSelector);
            });

        } else if (this.category) {
            var categoryName = that.category.name;
            var hits = categoryName != 'publisher' ? result.hits.hits : result.aggregations.publishers.buckets;

            $.each(hits, function(i, hit) {
                var hitToProcess = categoryName != 'publisher' ? hit : hit.publisher_info.hits.hits[0];
                that.processHit(hitToProcess, categoryName, that.containerSelector);
            });
        }

    },
    clearResults: function() {
        $(this.containerSelector).empty();
    },
    hideResults: function() {
        $(this.containerSelector).hide();
    },
    focusoutHandler: function (e) {
        if ($(this.inputSelector).val().length === 0) {
            this.clearResults();
        }
    },
    showResults: function() {
        $(this.containerSelector).show();
    },
    clearInput: function() {
        $(this.inputSelector).val('');
    },
    inputHandler: function(e) {
        if(e.keyCode == 27) {
            this.clearResults();
            this.clearInput();
            return;
        }

        var query = $(this.inputSelector).val();

        if (query.length < 1) {
            this.clearResults();
        } else {
            this.search(query);
        }
    },
    processHit: function(hit, category, container) {
        var templateObject = this.hitProcessors[category](hit);
        var dom = this.hitTemplates[category](templateObject);
        $(dom).appendTo(container);
    },


    /**
    * Instellen van extra parameters die worden meegegeven aan de backend
    *
    * Deze parameters worden samengevoegd met het resultaat van  this.getParams
    * @param {Object}
    */
    setAdditionalParams: function(params) {
        this.additionalParams = params;
    },

    /**
    * Instellen van extra parameters die worden meegegeven aan de backend die niet gewijzigd kunnen worden
    *
    * Deze parameters worden samengevoegd met het resultaat van  this.getParams
    * @param {Object}
    */
    setFixedParams: function(params) {
        this.fixedParams = params;
    },

    setCategories: function(categories) {
        this.category = null;
        this.categories = categories;
    },

    setCategory: function(category) {
        this.categories = null;
        this.category = category;
    },

    setAdditionalClasses: function(classes) {
        this.additionalClasses = classes;
    },
}